import WeightHeightQuestions from './WeightHeightQuestions';

export default WeightHeightQuestions;
